import AmexResyCreditMGM from './AmexResyCreditMGM';

export default AmexResyCreditMGM;
